import { IconPanoramaStr } from '../../Icon';
import { YMapControlButtonTemplate } from '../Button';
import { YMapControl, YMapControlProps } from '../Control';
// @ts-ignore
import { ymaps } from '../../ApiProvider';

interface YMapControlPanoramaProps extends YMapControlProps {
    onOpen?: () => void;
}

const baseClass = 'YMapControlPanorama';

export function YMapControlPanorama({
    className,
    index,
    dataTest = 'ymap-panorama',
    onOpen,
    title
}: YMapControlPanoramaProps) {
    YMapControlPanoramaY.use({
        index,
        dataTest,
        className,
        onOpen,
        title
    } as YMapControlPanoramaProps);

    return null;
}

class YMapControlPanoramaY extends YMapControl<
    YMapControlPanoramaProps,
    ymaps.control.IButton
> {
    protected create() {
        return (new this.ymaps.control.Button({
            data: this.props,
            options: {
                layout: this.layoutClass()
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any) as unknown) as ymaps.control.IButton;
    }

    protected template() {
        const { props } = this;

        // eslint-disable-next-line new-cap
        return YMapControlButtonTemplate({
            dataTest: props.dataTest,
            className: `${baseClass} ${props.className ?? ''}`,
            children: IconPanoramaStr,
            title: props.title
        });
    }

    protected layoutClass() {
        const Layout = super.layoutClass();

        return class YMapControlCloseLayout extends Layout {
            build() {
                super.build();
                const el = this.getElement().querySelector(`.${baseClass}`);

                if (! el) throw new Error(`element not found in ${el}`);

                const onOpen = this.getData().data.get('onOpen');

                if (! onOpen) {
                    throw new Error(`Not passed onOpen callback in props ${el}`);
                }

                el.addEventListener('click', onOpen);
                const dispose = this.dispose;

                this.dispose = () => {
                    dispose();
                    el.removeEventListener('click', onOpen);
                };
            }
        };
    }
}
